module.exports = __webpack_public_path__ + "media/images/background-hr-pattern-171fa4ff5f2b7ed0ccc81ac74659f3a0.svg";